<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <!--<div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Assessments</h1>
                </div>-->

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">360 Assessments</h1>

                    <!--<a (click)="takeAssessment()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" [ngClass]="{'btn-primary': canTakeAssessment, 'btn-gray': !canTakeAssessment}">
                        <i class="fas fa-arrow-right text-white-50"> <span class="button-text">Begin assessment</span></i>
                    </a>-->
                </div>



                <div class="card shadow noActionButtons">
                    <div class="container-fluid">
                        <div class="row">
                            <!-- <div class="col-sm-9 table-actions">
                    <div (click)="takeAssessment()" [ngClass]="{'icon_disabled': canTakeAssessment == false}">
                        <i class="material-icons rotate180" [ngClass]="{'icon_disabled': canTakeAssessment == false}">keyboard_backspace</i>
                        <span style="">Take</span>
                    </div>
                </div> -->
                        </div>

                        <div class="" style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [floatingFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="assessments"
                                             [columnDefs]="dataHeaders"
                                             [enableSorting]="true"
                                             [enableColResize]="true"
                                             (rowClicked)="onRowClicked($event)"
                                             (gridReady)="onGridReady($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowSelection]="rowSelection"
                                             (rowSelected)="onRowSelected($event)"
                                             (selectionChanged)="onSelectionChanged($event)">
                            </ag-grid-angular>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>